import { combineReducers } from 'redux'
import { createAction, createAsyncAction, createReducer, isActionOf } from 'typesafe-actions'
import { ByUserQuery, StatisticsData, ByTaskData } from '../../../responses/statistics'
import * as O from 'fp-ts/Option'
import { Option } from 'fp-ts/Option'
import { RootEpic } from '../../root'
import { filter, map, mergeMap } from 'rxjs/operators'
import { apiRequests } from '../../../http/config'
import { toastFailedResponse } from '../../../components/controls/Toaster/Toaster'
import {
    HideConfiguration,
    OpenConfiguration,
    SortConfiguration
} from '../../../components/pages/statistics/StatisticsTable/configuration'
import { payloadReducer } from '../../../utils/redux-utils'
import { ID } from '../../../types/UtilityTypes'
import { SortDirection } from '../../../constants/direction'
import { User } from '../../../responses/users'
import {Direction} from '../../../responses/refs/refs'
import {RequestStatus} from '../../../responses/response'

export const byTaskActions = {
    data: createAsyncAction(
        '@STATISTICS_BY_TASK/DATA_REQUEST',
        '@STATISTICS_BY_TASK/DATA_SUCCESS',
        '@STATISTICS_BY_TASK/DATA_FAILURE',
    )<ByUserQuery, StatisticsData<ByTaskData>, void>(),
    setHiddenColumns: createAction('@STATISTICS_BY_TASK/SET_HIDDEN_COLUMNS')<HideConfiguration[]>(),
    toggleRow: createAction('@STATISTICS_BY_TASK/TOGGLE_ROW')<Record<ID, OpenConfiguration>>(),
    setManagers: createAction('@STATISTICS_BY_TASK/SET_MANAGERS')<User[]>(),
    setDirections: createAction('@STATISTICS_BY_PROJECT/SET_DIRECTIONS')<Direction[]>(),
    setUsers: createAction('@STATISTICS_BY_TASK/SET_USERS')<User[]>(),
    setSort: createAction('@STATISTICS_BY_TASK/SET_SORT')<SortConfiguration>(),
    clearFilters: createAction('@STATISTICS_BY_TASK/CLEAR_FILTERS')()
}

export interface ByTaskState {
    data: Option<StatisticsData<ByTaskData>>,
    managers: User[],
    directions: Direction[],
    users: User[],
    hide: HideConfiguration[],
    open: Record<ID, OpenConfiguration>,
    sort: SortConfiguration,
    state: RequestStatus
}

export const byTaskReducer = combineReducers<ByTaskState>({
    data: createReducer<Option<StatisticsData<ByTaskData>>>(O.none)
        .handleAction(byTaskActions.data.success, (_, action) => O.of(action.payload)),
    managers: createReducer<User[]>([])
        .handleAction(byTaskActions.setManagers, payloadReducer)
        .handleAction(byTaskActions.clearFilters, () => []),
    directions: createReducer<Direction[]>([])
        .handleAction(byTaskActions.setDirections, payloadReducer)
        .handleAction(byTaskActions.clearFilters, () => []),
    users: createReducer<User[]>([])
        .handleAction(byTaskActions.setUsers, payloadReducer)
        .handleAction(byTaskActions.clearFilters, () => []),
    hide: createReducer<HideConfiguration[]>([])
        .handleAction(byTaskActions.setHiddenColumns, payloadReducer),
    open: createReducer<Record<ID, OpenConfiguration>>({})
        .handleAction(byTaskActions.data.success, () => ({}))
        .handleAction(byTaskActions.toggleRow, payloadReducer),
    sort: createReducer<SortConfiguration>({group: '', name: '', direction: SortDirection.ASC})
        .handleAction(byTaskActions.setSort, payloadReducer),
    state: createReducer<RequestStatus>(RequestStatus.INITIAL)
        .handleAction(byTaskActions.data.request, () => RequestStatus.FETCHING)
        .handleAction(byTaskActions.data.success, () => RequestStatus.SUCCESS)
        .handleAction(byTaskActions.data.failure, () => RequestStatus.FAILURE),
})

export const byClientEpic: RootEpic = action$ => action$.pipe(
    filter(isActionOf(byTaskActions.data.request)),
    mergeMap(action => apiRequests.statistics.byTask({query: action.payload})),
    map(({response}) => response.success ?
        byTaskActions.data.success(response) :
        byTaskActions.data.failure(toastFailedResponse(response, 'Не удалось запросить данные диаграммы'))
    ),
)
export const byTaskEpic: RootEpic = action$ => action$.pipe(
    filter(isActionOf(byTaskActions.data.request)),
    mergeMap(action => apiRequests.statistics.byTask({
        query: action.payload
    })),
    map(res => res.response.success?
        byTaskActions.data.success(res.response):
        byTaskActions.data.failure(toastFailedResponse(res.response, 'Загрузка статистики по задачам не удалась'))
    )
)